import type { ClientRankingRow, Provenance } from '@losan/core';
import { DemoBadge } from './DemoBadge.js';

const eurFmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const intFmt = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 });
const pctFmt = new Intl.NumberFormat('es-ES', { style: 'percent', maximumFractionDigits: 1, signDisplay: 'exceptZero' });

interface Props {
  rows: ClientRankingRow[];
  provenance: Provenance;
}

export function ClientRankingTable({ rows, provenance }: Props) {
  if (rows.length === 0) {
    return (
      <div className="section ranking">
        <h2>Top clientes <DemoBadge provenance={provenance} /></h2>
        <div className="empty-hint">No hay ventas que mostrar con los filtros actuales.</div>
      </div>
    );
  }
  return (
    <div className="section ranking">
      <h2>Top tiendas <DemoBadge provenance={provenance} /></h2>
      <div className="ranking-table-wrap">
        <table className="ranking-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Cliente</th>
              <th className="num">Facturación</th>
              <th className="num">Unidades</th>
              <th className="num">vs LY</th>
              <th className="num">% obj.</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.clientId}>
                <td className="rank">{i + 1}</td>
                <td className="name" title={r.clientId}>{r.commercialName}</td>
                <td className="num strong">{eurFmt.format(r.revenueEUR)}</td>
                <td className="num">{intFmt.format(r.units)}</td>
                <td className={`num ${yoyClass(r.yoyPct)}`}>{formatYoy(r.yoyPct)}</td>
                <td className={`num ${targetClass(r.targetPct)}`}>{formatTargetPct(r.targetPct)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function yoyClass(yoy: number): string {
  if (!Number.isFinite(yoy)) return 'pos';
  return yoy >= 0 ? 'pos' : 'neg';
}
function formatYoy(yoy: number): string {
  if (!Number.isFinite(yoy)) return 'nuevo';
  return pctFmt.format(yoy);
}
function targetClass(pct: number): string {
  if (pct >= 1) return 'pos';
  if (pct >= 0.7) return '';
  return 'neg';
}
function formatTargetPct(pct: number): string {
  if (pct === 0) return '—';
  return `${Math.round(pct * 100)}%`;
}
